import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_qna = `${hostApi}/api/qnas`;

function getQnaList(params)
{
    return Vue.prototype.$http.get(api_qna, { params });
}

function getQna(id)
{
    return Vue.prototype.$http.get(`${api_qna}/${id}`);
}

function createQna(item)
{
    return Vue.prototype.$http.post(`${api_qna}`, item);
}

function cancelQna(id) 
{
    return Vue.prototype.$http.post(`${api_qna}/cancel/${id}`);
}

function updateQna(item)
{
    return Vue.prototype.$http.put(`${api_qna}/${item.id}`, item);
}



export {
    getQnaList,
    getQna,
    createQna,
    cancelQna,
    updateQna,
};
